/* ===================================================================
   KAAYU MOTION
   Scroll-reveal for elements marked [data-kaayu-rise].

   Progressive enhancement, deliberately:
   - the CSS only hides an element once this script has added
     .kaayu-motion-ready to <html>, so with JS off nothing is hidden
   - honours prefers-reduced-motion by revealing everything at once
   - uses IntersectionObserver; where unsupported, everything is shown
   - unobserves after reveal, so it never re-runs

   Loaded by the sections that use it, not globally.
   =================================================================== */
(function () {
  'use strict';

  var SEL = '[data-kaayu-rise]';
  var READY = 'kaayu-motion-ready';
  var IN = 'is-in';

  function showAll() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) els[i].classList.add(IN);
  }

  function init() {
    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) {
      document.documentElement.classList.add(READY);
      showAll();
      return;
    }

    // only now does the CSS start hiding things
    document.documentElement.classList.add(READY);

    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (!e.isIntersecting) continue;
        e.target.classList.add(IN);
        io.unobserve(e.target);
      }
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      // stagger siblings so a row resolves left to right
      var step = parseInt(els[i].getAttribute('data-kaayu-rise'), 10);
      if (step > 0) els[i].style.transitionDelay = Math.min(step, 8) * 70 + 'ms';
      io.observe(els[i]);
    }

    // anything already on screen at load reveals immediately
    window.setTimeout(function () {
      var all = document.querySelectorAll(SEL);
      for (var j = 0; j < all.length; j++) {
        var r = all[j].getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) all[j].classList.add(IN);
      }
    }, 40);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
